// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmLanguageNotification = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			value: 'language-notification',
			activeClass: 'language-notification--active',
			$closeBtn: $ ('.language-notification__close-btn')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function ($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		methods.get = function ($context) {
			var getStorage = store.get(settings.value);
			if (getStorage != true) {
				$context.addClass(settings.activeClass);
			}
		}

		// Bind events
		methods.events = function($context) {

			// Close button for language notification
			settings.$closeBtn.on('click.lmLanguageNotification', function(event) {
				event.preventDefault();
				store.set(settings.value, true)
				$context.removeClass(settings.activeClass);
			});
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);

			methods.events($context);
			methods.get($context);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.language-notification').length) {
		$('.language-notification').lmLanguageNotification();
	}

}(jQuery));